import { analysedialogTexts, type IAnalyseDialogTexts } from './languageTexts/analyseDialog';
import { attachmentsTexts, type IAttachmentsTexts } from './languageTexts/attachmentsTexts';
import { availabilitiesTexts, type IAvailabilitiesTexts } from './languageTexts/availability';
import { type businessesTexts, businesssTexts } from './languageTexts/business';
import { categorizedialogTexts, type ICategorizeDialogTexts } from './languageTexts/categorizeDialog';
import { certificatesTexts, type ICertificatesTexts } from './languageTexts/certificates';
import { chatAgentTexts, type IChatAgentTexts } from './languageTexts/chatAgent';
import { competenceTexts, type ICompetenceTexts } from './languageTexts/competence';
import { countriesTexts, type ICountriesTexts } from './languageTexts/countries';
import { dashboardTexts, type IDashboardTexts } from './languageTexts/dashboard';
import { emailTexts, type IEmailTexts } from './languageTexts/emailTexts';
import { employeedevelopmentTexts, type IEmployeeDevelopmentTexts } from './languageTexts/employeedevelopmentTexts';
import { employeesTexts, type IEmployeesTexts } from './languageTexts/employees';
import { employeeTalkTexts, type IEmployeeTalkTexts } from './languageTexts/employeeTalk';
import { entityPageTexts, type IEntityPageTexts } from './languageTexts/entityPage';
import { errorTexts, type IErrorTexts } from './languageTexts/errorTexts';
import { firstExpirienceDialog, type IFirstExpirienceDialogTexts } from './languageTexts/firstExpirienceDialogTexts';
import { helpdialogTexts, type IHelpDialogTexts } from './languageTexts/helpDialog';
import { entityTypesTexts, type IEntityTypesTexts } from './languageTexts/IEntityTypesTexts';
import { type ILanugageNamesTexts, lanugagenamesTexts } from './languageTexts/lanugageNames';
import { type ILayoutTexts, layoutTexts } from './languageTexts/layout';
import { type ILoggedinTexts, loggedinTexts } from './languageTexts/loggedin';
import { type IMessagesTexts, messagesTexts } from './languageTexts/messages';
import { type INavigationTexts, navigationTexts } from './languageTexts/navigation';
import { type INotloggedinTexts, notloggedinTexts } from './languageTexts/notloggedin';
import { oftenUsedTranslations } from './languageTexts/oftenUsed';
import { type IOnboardingTexts, onboardingTexts } from './languageTexts/onboarding';
import { type IOppoTexts, oppoTexts } from './languageTexts/opportunities';
import { type IOrgUnitTexts, orgunitTexts } from './languageTexts/orgUnit';
import { type IProductsTexts, productsTexts } from './languageTexts/products';
import { type IProfileTexts, profileTexts } from './languageTexts/profile';
import { type IProfileSettingsTexts, profilesettingsTexts } from './languageTexts/profileSettings';
import { type IProjectsTexts, projectsTexts } from './languageTexts/projects';
import { type IRegisterCompanyTexts, registerCompanyTexts } from './languageTexts/registerCompany';
import { type IRegistrationConfig, registrationConfigTexts } from './languageTexts/registrationConfig';
import { type IRestDocuTexts, restDocuTexts } from './languageTexts/restDocu';
import { type IRolesTexts, rolesTexts } from './languageTexts/roles';
import { type ISalesTexts, salesTexts } from './languageTexts/sales';
import { type ISettingsTexts, settingsTexts } from './languageTexts/settings';
import { type ISkillCategoriesTexts, skillcategoriesTexts } from './languageTexts/skillCategories';
import { type ISkillTexts, skillTexts } from './languageTexts/skills';
import { type IStartPagesTexts, startPagesTexts } from './languageTexts/startPages';
import { type ISuggestionsTexts, suggestionsTexts } from './languageTexts/suggestions';
import { type IUserDialogTexts, userdialogTexts } from './languageTexts/userDialog';

export enum ELanguage {
    de = 'de',
    en = 'en',
    th = 'th',
}

export interface ILanguage {
    error: IErrorTexts;
    analyseDialog: IAnalyseDialogTexts;
    availability: IAvailabilitiesTexts;
    businesses: businessesTexts;
    categorizeDialog: ICategorizeDialogTexts;
    certificates: ICertificatesTexts;
    competence: ICompetenceTexts;
    countries: ICountriesTexts;
    employeeDevelopment: IEmployeeDevelopmentTexts;
    employees: IEmployeesTexts;
    entityPage: IEntityPageTexts;
    firstExpirienceDialog: IFirstExpirienceDialogTexts;
    entityTypes: IEntityTypesTexts;
    helpDialog: IHelpDialogTexts;
    languageNames: ILanugageNamesTexts;
    layout: ILayoutTexts;
    loading: string;
    loggedin: ILoggedinTexts;
    navigation: INavigationTexts;
    notloggedin: INotloggedinTexts;
    opportunities: IOppoTexts;
    orgUnit: IOrgUnitTexts;
    products: IProductsTexts;
    profile: IProfileTexts;
    profileSettings: IProfileSettingsTexts;
    projects: IProjectsTexts;
    registrationConfig: IRegistrationConfig;
    sales: ISalesTexts;
    settings: ISettingsTexts;
    skillCategories: ISkillCategoriesTexts;
    skills: ISkillTexts;
    startPages: IStartPagesTexts;
    userDialog: IUserDialogTexts;
    roles: IRolesTexts;
    emailTexts: IEmailTexts;
    registerCompany: IRegisterCompanyTexts;
    restDocu: IRestDocuTexts;
    attachments: IAttachmentsTexts;
    chatAgent: IChatAgentTexts;
    dashboard: IDashboardTexts;
    suggestions: ISuggestionsTexts;
    employeeTalk: IEmployeeTalkTexts;
    onboarding: IOnboardingTexts;
    messages: IMessagesTexts;
}

/**
 * Retrieves the language data.
 *
 * @returns {ILangData} The language data.
 */
function getLangData(): ILangData {
    const data: ILangData = {} as ILangData;
    Object.values(ELanguage).forEach((lang) => {
        data[lang] = {
            analyseDialog: analysedialogTexts[lang] ? analysedialogTexts[lang] : analysedialogTexts.en,
            availability: availabilitiesTexts[lang] ? availabilitiesTexts[lang] : availabilitiesTexts.en,
            businesses: businesssTexts[lang] ? businesssTexts[lang] : businesssTexts.en,
            categorizeDialog: categorizedialogTexts[lang] ? categorizedialogTexts[lang] : categorizedialogTexts.en,
            certificates: certificatesTexts[lang] ? certificatesTexts[lang] : certificatesTexts.en,
            competence: competenceTexts[lang] ? competenceTexts[lang] : competenceTexts.en,
            employees: employeesTexts[lang] ? employeesTexts[lang] : employeesTexts.en,
            entityPage: entityPageTexts[lang] ? entityPageTexts[lang] : entityPageTexts.en,
            entityTypes: entityTypesTexts[lang] ? entityTypesTexts[lang] : entityTypesTexts.en,
            firstExpirienceDialog: firstExpirienceDialog[lang] ? firstExpirienceDialog[lang] : firstExpirienceDialog.en,
            helpDialog: helpdialogTexts[lang] ? helpdialogTexts[lang] : helpdialogTexts.en,
            layout: layoutTexts[lang] ? layoutTexts[lang] : layoutTexts.en,
            loading: (oftenUsedTranslations[lang] ? oftenUsedTranslations[lang] : oftenUsedTranslations.en).loading,
            loggedin: loggedinTexts[lang] ? loggedinTexts[lang] : loggedinTexts.en,
            navigation: navigationTexts[lang] ? navigationTexts[lang] : navigationTexts.en,
            notloggedin: notloggedinTexts[lang] ? notloggedinTexts[lang] : notloggedinTexts.en,
            opportunities: oppoTexts[lang] ? oppoTexts[lang] : oppoTexts.en,
            orgUnit: orgunitTexts[lang] ? orgunitTexts[lang] : orgunitTexts.en,
            products: productsTexts[lang] ? productsTexts[lang] : productsTexts.en,
            profile: profileTexts[lang] ? profileTexts[lang] : profileTexts.en,
            profileSettings: profilesettingsTexts[lang] ? profilesettingsTexts[lang] : profilesettingsTexts.en,
            projects: projectsTexts[lang] ? projectsTexts[lang] : projectsTexts.en,
            registrationConfig: registrationConfigTexts[lang]
                ? registrationConfigTexts[lang]
                : registrationConfigTexts.en,
            sales: salesTexts[lang] ? salesTexts[lang] : salesTexts.en,
            settings: settingsTexts[lang] ? settingsTexts[lang] : settingsTexts.en,
            skillCategories: skillcategoriesTexts[lang] ? skillcategoriesTexts[lang] : skillcategoriesTexts.en,
            skills: skillTexts[lang] ? skillTexts[lang] : skillTexts.en,
            userDialog: userdialogTexts[lang] ? userdialogTexts[lang] : userdialogTexts.en,
            countries: countriesTexts[lang] ? countriesTexts[lang] : countriesTexts.en,
            languageNames: lanugagenamesTexts[lang] ? lanugagenamesTexts[lang] : lanugagenamesTexts.en,
            employeeDevelopment: employeedevelopmentTexts[lang]
                ? employeedevelopmentTexts[lang]
                : employeedevelopmentTexts.en,
            startPages: startPagesTexts[lang] ? startPagesTexts[lang] : startPagesTexts.en,
            error: errorTexts[lang] ? errorTexts[lang] : errorTexts.en,
            roles: rolesTexts[lang] ? rolesTexts[lang] : rolesTexts.en,
            emailTexts: emailTexts[lang] ? emailTexts[lang] : emailTexts.en,
            registerCompany: registerCompanyTexts[lang] ? registerCompanyTexts[lang] : registerCompanyTexts.en,
            restDocu: restDocuTexts[lang] ? restDocuTexts[lang] : restDocuTexts.en,
            attachments: attachmentsTexts[lang] ? attachmentsTexts[lang] : attachmentsTexts.en,
            chatAgent: chatAgentTexts[lang] ? chatAgentTexts[lang] : chatAgentTexts.en,
            dashboard: dashboardTexts[lang] ? dashboardTexts[lang] : dashboardTexts.en,
            suggestions: suggestionsTexts[lang] ? suggestionsTexts[lang] : suggestionsTexts.en,
            employeeTalk: employeeTalkTexts[lang] ? employeeTalkTexts[lang] : employeeTalkTexts.en,
            onboarding: onboardingTexts[lang] ? onboardingTexts[lang] : onboardingTexts.en,
            messages: messagesTexts[lang] ? messagesTexts[lang] : messagesTexts.en,
        };
    });

    return data;
}

/**
 * Retrieves the language texts based on the specified language.
 *
 * @param {string} lang - The language code.
 *
 * @returns {ILanguage} The language texts.
 */
export function getLanguageTexts(lang: ELanguage) {
    // return langData['th'];
    const langData = getLangData();
    if (lang in ELanguage) {
        return langData[lang as ELanguage];
    }
    return langData.en;
}

/**
 * Function to find and return a matching language.
 *
 * @param {readonly string[]} langs - An array of languages to search for a match.
 * @returns {string} The matching language.
 */
export function findMatchingLanguage(langs: readonly string[]): ELanguage {
    const shortLangs = langs.map((lang) => {
        const index = lang.indexOf('-');
        if (index > -1) {
            const shortLang = lang.substring(0, index);
            return shortLang;
        }
        return lang;
    });

    const wantedLang = shortLangs.find((lang) => lang in ELanguage);

    if (!wantedLang) {
        return ELanguage.en;
    }
    return wantedLang as ELanguage;
}

type ILangData = {
    [lang in ELanguage]: ILanguage;
};

export const languageToCountryMap: Record<ELanguage, string[]> = {
    de: ['de', 'at', 'ch', 'li', 'lu', 'be'],
    en: ['gb', 'usa', 'au', 'ca', 'ie', 'nz', 'sg', 'za'],
    th: ['th'],
};

export const countryToLanguageMap: Record<string, ELanguage> = {};

// Füllen der umgekehrten Zuordnung
for (const [language, countries] of Object.entries(languageToCountryMap)) {
    for (const country of countries) {
        countryToLanguageMap[country] = language as ELanguage;
    }
}

// Funktion, um die Sprache eines Landes zu erhalten
/**
 * Retrieves the language of a given country.
 * @param {string} country - The country for which the language is to be retrieved.
 * @returns {ELanguage} - The language of the country.
 */
export function getLanguageOfCountry(country: keyof ICountriesTexts): ELanguage {
    return countryToLanguageMap[country];
}
